import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=30d3761f&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=ts&"
export * from "./Init.vue?vue&type=script&lang=ts&"
import style0 from "./Init.vue?vue&type=style&index=0&id=30d3761f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3761f",
  null
  
)

export default component.exports